import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/TweenMax.min.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'


$(document).ready(function(){
    $('.section1').addClass('active')
    setTimeout(function(){
        $('.top-line-cont .banner-line b').eq(0).addClass('active')
    },1000)

    //移动端首屏视频播放
    var $video = $('.section1 video')[0]
    $video.onplay = function(){
        $('.section1 .video .play-btn').hide()
    }
    $video.onpause = function(){
        $('.section1 .video .play-btn').show()
    }
    $('.section1 .video .play-btn').on('click',function(){
        $video.play()
        $(this).hide()
    })
    // section2 点击下载按钮显示表单
    // $('.section2 .sec2-text .link a').on('click',function(){
    //     $('.download-form').fadeIn(300)
    //     $('body').css({
    //         'height':'100vh',
    //         'overflow-y':'hidden'
    //     })
    // })
    $('.download-form .close-btn').on('click',function(){
        $('.download-form').fadeOut(300)
        $('body').css({
            'height':'auto',
            'overflow-y':'auto'
        })
    })


    // section2 点击图片显示大图
    $('.section2 .sec2-img .layer-2 li').on('click',function(){
        let index = $(this).index()
        $('.sec2-hidden-img .img>div').eq(index).show().siblings().hide()
        $('.sec2-hidden-img').addClass('active')
    })
    $('.sec2-hidden-img .close').on('click',function(){
        $('.sec2-hidden-img').removeClass('active')
    })

    // sec3 轮播
    let sec3video1 = $('.section3 .imgSwiper .swiper-slide').eq(0).find('video')
    if(sec3video1.length > 0){
        sec3video1[0].play()
    }

    var swiper2 = new Swiper('.section3 .imgSwiper', {
        watchSlidesProgress: true,
        speed: 800,//限制滚轴时间间隔
        // allowTouchMove: false,
        effect: "creative",
        creativeEffect: {
            prev: {
                shadow: true,
                translate: ["-20%", 0, -1],
            },
                next: {
                translate: ["100%", 0, 0],
            },
        },
        navigation: {//按钮
            nextEl: '.section3 .swiper-button-next',
            prevEl: '.section3 .swiper-button-prev',
        },
        on: {
            init: function() {
                $('.section3 .sec3-tab .tab .item').eq(this.realIndex).addClass('hover')
                let total = this.slides.length
                total = total > 9 ? total : '0' + total
                let active = this.realIndex+1 > 9 ? this.realIndex+1 : '0' + (this.realIndex+1)

                $('.section3 .text-cont .num .total').html(total)
                $('.section3 .text-cont .num .active').html(active)
            },
            slideChangeTransitionStart: function(){
                $('.section3 .sec3-tab .tab .item').eq(this.realIndex).addClass('hover').siblings().removeClass('hover')
                let active = this.realIndex+1 > 9 ? this.realIndex + 1 : '0' + (this.realIndex+1)
                $('.section3 .text-cont .num .active').html(active)

                $('.section3 .imgSwiper .swiper-slide').each(function(){
                    if(!$(this).hasClass('swiper-slide-active')){
                      if($(this).find('video').length > 0){
                        $(this).find('video')[0].pause()
                      }
                    }
                });
        
                let video = $(this.slides[this.activeIndex]).find('video')
                if(video.length > 0){
                    video[0].play()
                }
            }
        },
    });

    var swiper3 = new Swiper('.section3 .text-cont .mySwiper', {
        effect : 'fade',
        allowTouchMove: false,
        fadeEffect: {
          crossFade: true,
        },
        controller: {
            control: swiper2, //控制Swiper1
        },
    })
    swiper2.controller.control = swiper3;
    swiper3.controller.control = swiper2;

    $('.section3 .sec3-tab .tab .item').on('click',function(){
        let index = $(this).index()
        swiper2.slideTo(index)
    })

    // section4 轮播
    var swiper6 = new Swiper('.section4 .left .mySwiper', {
        effect : 'fade',
        allowTouchMove: false,
        fadeEffect: {
          crossFade: true,
        },
        on:{
            init: function(swiper){
                $('.section4 .right .item').eq(this.realIndex).addClass('active')
            },
            slideChangeTransitionStart: function(){
                $('.section4 .right .item').eq(this.realIndex).addClass('active').siblings().removeClass('active')
            },
        }
    })
    $('.section4 .right .item').hover(function(){
        let index = $(this).index()
        swiper6.slideTo(index)
    })

    // section5 轮播
    var swiper4 = new Swiper('.section5 .left .mySwiper', {
        effect : 'fade',
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
        on:{
            init: function(swiper){
                $('.section5 .right .mySwiper .swiper-slide').eq(this.realIndex).addClass('active')
            },
            slideChangeTransitionStart: function(){
                swiper5.slideTo(this.realIndex)
                $('.section5 .right .mySwiper .swiper-slide').eq(this.realIndex).addClass('active').siblings().removeClass('active')
            },
        }
    })
    var swiper5 = new Swiper('.section5 .right .mySwiper', {
        direction: 'horizontal',
        slidesPerView : 3,
        spaceBetween: 5,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768: {
                direction: 'horizontal',
                slidesPerView: 3,
                spaceBetween: 20
            },
            1024:{
                direction: 'vertical',
                slidesPerView: 3,
                spaceBetween: 20
            },
            1280: {
                direction: 'vertical',
                slidesPerView: 3,
                spaceBetween: 40
            }
          },
    })

    $('.section5 .right .mySwiper .swiper-slide').on('click',function(){
        let index = $(this).index()
        console.log(index)
        swiper4.slideTo(index)
    })
})

$(document).scroll(function () {
    let scroH = $(document).scrollTop(); //滚动高度
    let viewH = $(window).height(); //可见高度

    if($('.section3 .imgSwiper .swiper-slide:nth-child(1) video').length > 0){
        let sec3video = $('.section3 .imgSwiper .swiper-slide:nth-child(1) video')[0]
        sec3video.play()
    }

    // banner位移效果
    if($('.section1 .video').length > 0){
        $('.section1 .video').css({
            'transform':'translateY('+ scroH / 3 +'px)'
        })
    }
    if($('.section1 .img').length > 0){
        $('.section1 .img').css({
            'transform':'translateY('+ scroH / 3 +'px)'
        })
    }
    
    $('.section1 .text').css({
        'transform':'translateY(-'+ scroH / 2 +'px)',
        'opacity': (1 - scroH/2000)
    })
    $('.section1 .jianbian').css({
        'height': scroH/2 +'px'
    })

    let sec1H = $('.section1').height() - viewH

    if (scroH > sec1H + viewH*2/3) {
        $('.section2').addClass('active')
    }
    if (scroH <= sec1H) {
        $('.section2').removeClass('active')
    }

    if($(window).width() > 1024){
        if (scroH > sec1H + viewH*2/3) {
            let ss = scroH - (sec1H + viewH*2/3)
            $('.section2 .ad .layer-1 b').css({
                transform: 'translateY(' + (ss * 0.15) + 'px)'
            });
            $('.section2 .ad .layer-2').css({
                transform: 'translateY(' + (ss * -0.2) + 'px)',
            });
        }
    }

    // section5 斜线
    let sec5Top = $('.section5').offset().top - viewH + $('.section5').outerHeight()/2
    if (scroH > sec5Top) {
        $('.section5 .line').addClass('active')
    }
})

// section2 位移错位效果
// var $sec2 = $('.section2');
// var WIDTH = $sec2.width();
// var HEIGHT = $sec2.height();
// var $ad = $('.ad');
// var $light = $ad.find('.light');
// var $layer1 = $ad.find('.layer-1');
// var $layer2 = $ad.find('.layer-2');
 
// function moveAd(e) {
//     var xPer = e.clientX / WIDTH;
//     var yPer = e.clientY / HEIGHT;
//     var rotateX = 5 - (yPer * 5);
//     var rotateY = -5 + (xPer * 5);
//     $ad.css({
//         transform: 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) '
//     });
//     var translateX = -5 + (xPer * 10);
//     var translateY = -5 + (yPer * 10);
//     $layer1.css({
//         transform: 'translateX(' + (translateX * 3) + 'px) translateY(' + (translateY * 3) + 'px)'
//     });
//     $layer2.css({
//         transform: 'translateX(' + (translateX) + 'px) translateY(' + (translateY) + 'px)',
//     });
//     var lightX = 20 - (xPer * 360);
//     var lightY = 120 - (yPer * 260);
//     $light.css({
//         transform: 'translateX(' + lightX + 'px) translateY(' + lightY + 'px)'
//     });
// }
// $sec2.on('mousemove', moveAd);
